<!--
 * @Description: 班次规则列表页面
 * @Author: wanqian
 * @Date: 2022-03-25 16:43:52
-->
<template>
   <div class="body-dutyrule-list">
     <el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 210px" v-model="filterParams.institutionId" filterable clearable 
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left">
        <span class="search-title">所属地区：</span>
        <el-cascader size="small" style="width: 210px"  v-model="searchArea" clearable filterable  
          :options="provinceList" placeholder="请输入/选择"
          :props="{checkStrictly: true,expandTrigger: 'hover',children:'subRegionList',label:'name',value:'id',}">
        </el-cascader>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">搜 索</el-button>
        <el-button v-if="dataPvgList.includes('INST_6_DUTY_RULE_CHG')" 
          size="small" @click="handleAddDutyRule(filterParams.institutionId)" type="primary" icon="icon-nav-add">新增班次</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <div class="back-card">
      <el-row type="flex" class="row-bg" :gutter="20">
        <el-col :span="8" v-for="item in dutyRules" :key="item.id">
          <el-card class="box-card" shadow="never" :body-style="{padding: '0px', 'background-color': '#FAFBFF',}">
            <div class="box-card-main">
              <div class="box-card-header">
                <div class="duty-rule-name">班次规则-{{item.institutionName}}</div>
                <el-button v-if="item.canAddRule" style="padding: 0; font-size: 26px; margin-left: 6px" 
                  type="text" @click="handleAddDutyRule(item.institutionId)">+</el-button>
              </div>
              <div style="margin-left: 10px">
                <el-table v-if="item.dutyRuleList && item.dutyRuleList.length"
                   style="background-color: #FAFBFF; height: 260px; overflow-y: auto; overflow-x: hidden;" 
                  :data="item.dutyRuleList" :header-cell-style="{'text-align': 'left'}" >
                  <el-table-column align="left" prop="name" label="班次名称" min-width="25%">
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="颜色" align="left" min-width="20%">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.color && scope.row.color.length" class="tag-color" 
                        :color="scope.row.color.indexOf('#') != -1 ? scope.row.color : ('#'+scope.row.color)">
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column align="left" label="时间段" min-width="32%">
                    <template slot-scope="scope">
                      <span>
                        {{timeFormat(scope.row.startTime) + '-' + (scope.row.spanDay ? '次日' : '') 
                          + timeFormat(scope.row.endTime)}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="right" min-width="23%">
                    <template slot-scope="scope">
                      <img width="16px" height="16px" class="img-edit mouse-pointer" 
                        src="@/assets/instmng/dutyrule/icon-dutyrule-edit.png"
                        @click="handleEditDutyRule(scope.$index, scope.row)" alt=""/>
                      <img width="16px" height="16px" class="mouse-pointer" 
                        src="@/assets/instmng/dutyrule/icon-dutyrule-delete.png"
                        @click="handleDeleteDutyRule(scope.$index, scope.row)" alt=""/>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-else class="div-no-rule">暂无数据</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
      :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
      layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
    <!-- 班次规则对话框 -->
    <duty-rule-form :visible="showDialog" :operate="operate" :dutyId="dutyId" :institutionId="institutionId" 
      @close-dialog="closeDialog"/>
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import DutyRuleForm from './components/DutyRuleForm.vue'

export default {
  name: 'DutyRuleList',

  components: {
    'duty-rule-form' : DutyRuleForm,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: 6,
      },
      searchArea: [],
      institutionList: null,
      srcInstitutionList: [],
      provinceList: null,
      pageSizes: [6, 12, 18],
      totalNumber: 0,
      dutyRules: [],

      // 以下是班次规则对话框组件使用
      showDialog: false,
      operate: '',
      dutyId: 0,
      institutionId: 0,
    }
  },
  
  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listDutyRules();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INST'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_DUTY_RULE_FILTER_DO).then(result => {
          if (result != null) {
            this.initFilterData(result.data);
            resolve();
          }
        })
      })
    },

    initFilterData(filterObj) {
      this.institutionList = filterObj.institutionList;
      this.srcInstitutionList = filterObj.institutionList;
      this.provinceList = filterObj.provinceList;
      if (this.globalData.adminType == 2) {
        this.$set(this.filterParams, 'institutionId', this.institutionList[0].id);
      }
    },
    
    listDutyRules() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_DUTY_RULES,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dutyRules = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    deleteDutyRule(id) {
      let params = {'id': id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_DUTY_RULE,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) return;
        this.listDutyRules();
      })
    },

    handleQuery() {
      this.filterParams.page = 1;
      if (this.searchArea.length > 0) {
        this.filterParams.provinceId = this.searchArea[0] ? this.searchArea[0] : "";
        this.filterParams.cityId = this.searchArea[1] ? this.searchArea[1] : "";
        this.filterParams.countyId = this.searchArea[2] ? this.searchArea[2] : "";
      } else {
        this.filterParams.provinceId = "";
        this.filterParams.cityId = "";
        this.filterParams.countyId = "";
      }
      this.listDutyRules();
    },

    handleAddDutyRule(institutionId) {
      this.showDialog = true;
      this.operate = "add";
      this.dutyId = 0;
      this.institutionId = institutionId;
    },

    handleEditDutyRule(_index, row) {
      this.showDialog = true;
      this.operate = "edit";
      this.dutyId = row.id;
      this.institutionId = 0;
    },

    closeDialog(refresh) {
      this.showDialog = false;
      if (refresh) {
        this.listDutyRules();
      }
    },

    handleDeleteDutyRule(_index, row) {
      let content = row.name + '（' + this.timeFormat(row.startTime) + '-' + this.timeFormat(row.endTime) + '）' 
        + '此班次将被删除，是否继续删除？';
      this.$confirm(content, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.deleteDutyRule(row.id);
      });
    },
    
    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listDutyRules();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listDutyRules();
    },

    timeFormat(time) {
      return this.dateUtil.timeFormat(time, "HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '机构管理', text2: '班次规则'});
    this.initData();
  }
}
</script>
<style>
.icon-nav-add {
    padding-right: 5px;
    width: 11px;
    height: 11px;
    content: url("../../assets/instmng/dutyrule/icon-dutyrule-nav-add.png");
}
.body-dutyrule-list .el-table th, .body-dutyrule-list .el-table tr {
  background-color: #FAFBFF;
}
.body-dutyrule-list .el-table__row > td {
  border: none;
}
.body-dutyrule-list .el-table::before {
  height: 0px;
}
/* 这里不删除暂时屏蔽，产品说后期可能还会去掉 */
/* 可以滚动，且滚动条不显示； */
/* .body-dutyrule-list ::-webkit-scrollbar {
  width: 0px !important;
} */
.body-dutyrule-list .el-table__empty-block {
  background-color: #FAFBFF;
}
</style>
<style scoped>
.body-dutyrule-list {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.search-title {
  color: #657180;
  font-size: 14px;
}
.main-line {
  height: 10px;
  background-color: #f2f3f4;
}
.row-bg {
  flex-wrap: wrap;
}
.back-card {
  margin: 21px 40px;
  text-align: left;
}
.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}
.box-card {
  margin-bottom: 20px;
}
.box-card-main {
  height: 310px;
  background-color: #FAFBFF;
}
.box-card-header {
  background-color: white;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  flex-direction: row;
  padding: 10px 12px; 
  justify-content: space-between;
  align-items: center;
}
.duty-rule-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis; /* 文本溢出时显示省略号来代表被修剪的文本 */
  display: -webkit-box; /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 文本需要显示多少行 */
}
.img-edit {
  margin: 0 15px 0 0;
}
.img-delete {
  margin: 0px 5px 0 0;
}
.tag-color {
  vertical-align: middle;
  width: 32px;
  height: 20px;
  border-width: 0;
  border-radius: 2px;
}
.div-no-rule {
  height: 260px;
  text-align: center;
  background-color:#FAFBFF;
  color: #909399;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/DutyRuleList.vue